/* ==========================================================================
   GR OLYMPIA - shared behaviour for all Olympia accordion panels
   Idempotent: safe to load or execute more than once. Each .gr-oly root is
   initialised at most once, and re-scans on Shopify section reloads.
   ========================================================================== */
(function () {
  if (window.__grOlympiaInit) { return; }
  window.__grOlympiaInit = true;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function storageGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function storageSet(key, val) {
    try { sessionStorage.setItem(key, val); } catch (e) { /* Safari private mode */ }
  }

  /* ---------- carousel progress bar ---------- */
  function wireProgress(root) {
    var track = root.querySelector('.gr-oly__track');
    var thumb = root.querySelector('.gr-oly__prog span');
    if (!track || !thumb) { return null; }

    function update() {
      var ratio = track.clientWidth / track.scrollWidth;
      var max   = track.scrollWidth - track.clientWidth;
      thumb.style.width = Math.min(100, ratio * 100) + '%';
      var travel = max > 0 ? (track.scrollLeft / max) : 0;
      var room   = track.clientWidth * (1 - ratio);
      thumb.style.transform = 'translateX(' + (travel * room) + 'px)';
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    return update;
  }

  /* ---------- accordion bar + lock countdown ---------- */
  function wireBar(root, onOpen) {
    var bar = root.querySelector('.gr-oly__bar');
    if (!bar) { return; }

    var cdEl     = bar.querySelector('.gr-oly__cd');
    var unlockAt = parseInt(bar.getAttribute('data-unlock') || '0', 10);
    var locked   = bar.classList.contains('is-locked');
    var timer    = null;

    function unlockNow() {
      locked = false;
      bar.classList.remove('is-locked');
      bar.removeAttribute('aria-disabled');
      if (cdEl && cdEl.parentNode) { cdEl.parentNode.removeChild(cdEl); }
      if (timer) { clearInterval(timer); timer = null; }
    }

    function tick() {
      var diff = unlockAt - Date.now();
      if (diff <= 0) { unlockNow(); return; }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600);  s -= h * 3600;
      var m = Math.floor(s / 60);    s -= m * 60;
      if (cdEl) { cdEl.textContent = pad(d) + 'D ' + pad(h) + 'H ' + pad(m) + 'M ' + pad(s) + 'S'; }
    }

    if (locked && unlockAt) { tick(); timer = setInterval(tick, 1000); }

    function setOpen(open) {
      if (locked && open) { return false; }
      bar.setAttribute('aria-expanded', String(open));
      /* the panel is the bar's adjacent sibling; CSS drives the reveal */
      if (open && typeof onOpen === 'function') { requestAnimationFrame(onOpen); }
      return true;
    }

    /* exposed so anchor links can open a panel without faking a click */
    bar.grOlyOpen = function () { return setOpen(true); };
    bar.grOlyLocked = function () { return locked; };

    bar.addEventListener('click', function () {
      if (locked) { return; }
      setOpen(bar.getAttribute('aria-expanded') !== 'true');
    });
  }

    /* ---------- anchor links ----------
     #panel-anchor opens that panel. #episode-anchor opens the panel that
     holds it, slides the carousel to that card, then scrolls the page to it.
     Runs on first load, on hashchange, and from links elsewhere on the site. */
  function elForHash(hash) {
    if (!hash || hash.length < 2) { return null; }
    try { return document.getElementById(decodeURIComponent(hash.slice(1))); }
    catch (e) { return null; }
  }

  function anchorOffset(el) {
    var n = parseFloat(getComputedStyle(el).getPropertyValue('--gr-anchor-offset'));
    return isNaN(n) ? 90 : n;
  }

  /* bring a carousel item to the same left edge the first item sits at */
  function scrollTrackTo(item) {
    var track = item.parentNode;
    if (!track || !track.classList || !track.classList.contains('gr-oly__track')) { return; }
    if (track.scrollWidth <= track.clientWidth + 1) { return; }
    var pad   = parseFloat(getComputedStyle(track).paddingLeft) || 0;
    var delta = item.getBoundingClientRect().left - track.getBoundingClientRect().left;
    track.scrollLeft += (delta - pad);
  }

  function goToHash(smooth) {
    var el = elForHash(window.location.hash);
    if (!el || !el.closest) { return; }

    var root = el.closest('.gr-oly');
    if (!root) { return; }

    var isBar   = el.classList.contains('gr-oly__bar');
    var bar     = isBar ? el : root.querySelector('.gr-oly__bar');
    var wasOpen = true;

    if (bar) {
      if (typeof bar.grOlyLocked === 'function' && bar.grOlyLocked()) {
        /* a locked panel cannot be opened from a link; land on the bar so the
           visitor gets the countdown instead of an unexplained jump */
        el = bar;
      } else {
        wasOpen = bar.getAttribute('aria-expanded') === 'true';
        if (typeof bar.grOlyOpen === 'function') { bar.grOlyOpen(); }
      }
    }

    var reduce = window.matchMedia &&
                 window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var behavior = (smooth && !reduce) ? 'smooth' : 'auto';
    var offset   = anchorOffset(root);
    var landed   = false;

    function land() {
      if (landed) { return; }
      landed = true;
      scrollTrackTo(el);
      var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      if (top < 0) { top = 0; }
      try { window.scrollTo({ top: top, behavior: behavior }); }
      catch (e) { window.scrollTo(0, top); }
    }

    /* the reveal is a .45s grid-template-rows transition, so a card inside a
       panel that was closed has no final position yet. Wait for the panel to
       settle, with a timeout in case transitionend never fires. */
    if (wasOpen || reduce) { requestAnimationFrame(land); return; }

    var panel = root.querySelector('.gr-oly__panel');
    if (!panel) { requestAnimationFrame(land); return; }

    panel.addEventListener('transitionend', function handler(e) {
      if (e.propertyName && e.propertyName !== 'grid-template-rows') { return; }
      panel.removeEventListener('transitionend', handler);
      land();
    });
    setTimeout(land, 650);
  }


  /* ---------- flip cards ---------- */
  function wireCards(root) {
    var cards = root.querySelectorAll('.gr-oly__card');
    if (!cards.length) { return; }

    function setFlipped(card, on) {
      card.setAttribute('aria-pressed', String(on));
      var close = card.querySelector('.gr-oly__close');
      if (close) { close.tabIndex = on ? 0 : -1; }
    }

    Array.prototype.forEach.call(cards, function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) { return; }
        setFlipped(card, card.getAttribute('aria-pressed') !== 'true');
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setFlipped(card, card.getAttribute('aria-pressed') !== 'true');
        }
        if (e.key === 'Escape') { setFlipped(card, false); }
      });
    });

    /* one-time nudge on the first card, fired when the row becomes visible */
    var firstCard = cards[0];
    var key = 'grOlyNudge:' + (root.id || 'gr-oly');
    var reduceMotion = window.matchMedia &&
                       window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!reduceMotion && storageGet(key) !== '1' && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) { continue; }
          io.disconnect();
          storageSet(key, '1');
          setTimeout(function () {
            if (firstCard.getAttribute('aria-pressed') === 'true') { return; }
            firstCard.classList.add('is-nudging');
            firstCard.addEventListener('animationend', function () {
              firstCard.classList.remove('is-nudging');
            }, { once: true });
          }, 450);
          return;
        }
      }, { threshold: 0.6 });
      io.observe(firstCard);
    }
  }

  /* ---------- YouTube facade ----------
     Nothing from youtube.com is requested until the poster is clicked. On
     click the facade is replaced with a nocookie iframe set to autoplay. */
  function wireVideos(root) {
    var vids = root.querySelectorAll('.gr-oly__vid');
    if (!vids.length) { return; }

    Array.prototype.forEach.call(vids, function (vid) {
      /* poster fallback: maxresdefault does not exist for every upload */
      var img = vid.querySelector('img[data-fallback]');
      if (img) {
        img.addEventListener('error', function handler() {
          img.removeEventListener('error', handler);
          img.src = img.getAttribute('data-fallback');
        });
      }

      vid.addEventListener('click', function () {
        if (vid.classList.contains('is-playing')) { return; }
        /* a locked episode must not be able to inject the iframe */
        if (vid.closest('.is-locked')) { return; }

        var id = vid.getAttribute('data-youtube-id');
        if (!id) { return; }

        var frame = document.createElement('iframe');
        frame.setAttribute('src',
          'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
          '?autoplay=1&rel=0&modestbranding=1&playsinline=1');
        frame.setAttribute('title', vid.getAttribute('data-title') || 'Video');
        frame.setAttribute('frameborder', '0');
        frame.setAttribute('allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        frame.setAttribute('allowfullscreen', '');

        vid.classList.add('is-playing');
        vid.appendChild(frame);
      });
    });
  }

  /* ---------- per-collection drop countdowns ----------
     Each tile carries its own unlock time. When it passes, the tile drops
     is-locked in place: gold title becomes white, countdown becomes the CTA.
     No reload, because the markup for both states is already present. */
  function wireDrops(root) {
    var cols = root.querySelectorAll('.gr-oly__col[data-unlock], .gr-oly__doc[data-unlock]');
    if (!cols.length) { return; }

    var pending = [];
    var timer = null;

    Array.prototype.forEach.call(cols, function (col) {
      var at = parseInt(col.getAttribute('data-unlock') || '0', 10);
      if (!at || !col.classList.contains('is-locked')) { return; }

      /* a locked tile still renders its link so it can go live in place */
      col.addEventListener('click', function (e) {
        if (col.classList.contains('is-locked')) { e.preventDefault(); }
      });

      pending.push({ col: col, at: at, out: col.querySelector('.gr-oly__drop-t') });
    });

    if (!pending.length) { return; }

    function tick() {
      for (var i = pending.length - 1; i >= 0; i--) {
        var it = pending[i];
        var diff = it.at - Date.now();
        if (diff <= 0) {
          it.col.classList.remove('is-locked');
          pending.splice(i, 1);
          continue;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600);  s -= h * 3600;
        var m = Math.floor(s / 60);
        if (it.out) {
          it.out.textContent = pad(d) + ' DAYS | ' + pad(h) + ' HRS | ' + pad(m) + ' MINS';
        }
      }
      if (!pending.length && timer) { clearInterval(timer); timer = null; }
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- confirmation modal ----------
     Used where the section renders .gr-oly__modal. This is the artifact the
     visitor screenshots and shows at the booth, so it carries the address they
     typed and the time it was issued. Sections without a modal fall back to the
     inline message, which is why every lookup here is optional. */
  function openModal(modal, email) {
    var slot = modal.querySelector('.gr-oly__modal-email');
    if (slot) { slot.textContent = email; }

    var stamp = modal.querySelector('.gr-oly__modal-stamp');
    if (stamp) {
      var now = new Date();
      stamp.textContent = now.toLocaleDateString() + ' ' +
        now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    var closer = modal.querySelector('.gr-oly__modal-close');
    if (closer) { closer.focus(); }

    function shut() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') { shut(); } }

    if (closer && !closer.grOlyBound) {
      closer.grOlyBound = true;
      closer.addEventListener('click', shut);
    }
    /* backdrop click closes, a click inside the card does not */
    if (!modal.grOlyBound) {
      modal.grOlyBound = true;
      modal.addEventListener('click', function (e) {
        if (e.target === modal) { shut(); }
      });
    }
    document.addEventListener('keydown', onKey);
  }

  /* ---------- Klaviyo email capture ----------
     Posts to Klaviyo's public /client/subscriptions endpoint. The subscriptions
     block is what grants email marketing consent - without it the profile lands
     on the list but is not subscribed, so it never receives a campaign. The
     list's own opt-in settings still apply on top, so a double opt-in list
     still sends its confirmation email. Nothing here is a secret: company_id is
     the same public key already used by onsite.js. */
  function wireSignup(root) {
    var forms = root.querySelectorAll('.gr-oly__signup');
    if (!forms.length) { return; }

    Array.prototype.forEach.call(forms, function (form) {
      var input = form.querySelector('input[type="email"]');
      var msg   = form.querySelector('.gr-oly__signup-msg');
      var modal = root.querySelector('.gr-oly__modal');
      if (!input || !msg) { return; }

      function say(text, state) {
        msg.className = 'gr-oly__signup-msg' + (state ? ' ' + state : '');
        msg.textContent = text;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (form.classList.contains('is-busy')) { return; }

        var email   = (input.value || '').trim();
        var company = form.getAttribute('data-company');
        var list    = form.getAttribute('data-list');

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          say(form.getAttribute('data-invalid') || 'Enter a valid email address.', 'is-error');
          input.focus();
          return;
        }
        if (!company || !list) {
          say('Signup is not configured yet.', 'is-error');
          return;
        }

        form.classList.add('is-busy');
        say('', '');

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': form.getAttribute('data-revision') || '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: form.getAttribute('data-source') || 'Olympia landing page',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                    }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          })
        }).then(function (res) {
          form.classList.remove('is-busy');
          if (res.ok) {
            /* {email} in the success message is swapped for what they typed, so
               the screenshot shown at the booth carries their own address */
            var okMsg = form.getAttribute('data-success') || "You're on the list.";
            if (modal) {
              openModal(modal, email);
              say('', '');
            } else {
              say(okMsg.replace('{email}', email), 'is-ok');
            }
            form.reset();
          } else {
            say(form.getAttribute('data-error') || 'Something went wrong. Please try again.', 'is-error');
          }
        }).catch(function () {
          form.classList.remove('is-busy');
          say(form.getAttribute('data-error') || 'Something went wrong. Please try again.', 'is-error');
        });
      });
    });
  }

  /* ---------- init ---------- */
  function initPanel(root) {
    if (root.hasAttribute('data-gr-init')) { return; }
    root.setAttribute('data-gr-init', '');
    var refreshProgress = wireProgress(root);
    wireBar(root, refreshProgress);
    wireCards(root);
    wireVideos(root);
    wireDrops(root);
    wireSignup(root);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.gr-oly');
    Array.prototype.forEach.call(nodes, initPanel);
  }

  function boot() {
    initAll();
    if (window.location.hash) { goToHash(false); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('hashchange', function () { goToHash(true); });

  /* theme editor: sections are re-rendered without a page load */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
